import { observer } from 'mobx-react';
import React from 'react';
import {
  ModalStore,
  ToolStore,
} from '../../stores';
import {
  Button,
  FlexLayout,
  LayoutTitle,
  ModalView,
  SubHeader,
  TextBox,
} from '../../components';
import { Date8 } from '../../utils/time';

interface ModalExcelProps {
  modalStore: ModalStore;
  toolStore: ToolStore;
}

@observer
export class ModalExcel extends React.Component<ModalExcelProps> {
  render() {
    const { modalStore } = this.props;
    const { toolStore } = this.props;

    return (
      <ModalView
        width={600}
        height={300}
        isVisible={modalStore.isVisibleExcel}
        onClose={() => modalStore.closeExcel()}
      >
        <FlexLayout
          isVertical={true}
          style={{
            padding: 8,
          }}
        >
          <LayoutTitle>엑셀 출력사유</LayoutTitle>

          <FlexLayout
            size={170}
            justify="center"
            align="center"
          >
            <span style={{ width: 50 }}>출력사유</span>
            <TextBox
              value={modalStore.excelRemark}
              isMultiline={true}
              onChange={(value) => { modalStore.excelRemark = value; }}
              style={{ border: '1px solid lightgray', borderRadius: '4px' }}
            >
            </TextBox>
          </FlexLayout>

          <FlexLayout
            justify="start"
            align="center"
          >
            <FlexLayout
              style={{ marginRight: 8 }}
              size={200}
              justify="center"
              align="center"
            >
              <span style={{ width: 50 }}>출력자명</span>
              <FlexLayout
                style={{ border: '1px solid lightgray', borderRadius: '4px', backgroundColor: '#F7F7F7' }}
                justify="center"
                align="center"
              >
                {modalStore.excelPerid}
              </FlexLayout>
              <FlexLayout
                style={{ border: '1px solid lightgray', borderRadius: '4px', backgroundColor: '#F7F7F7' }}
                justify="center"
                align="center"
              >
                {modalStore.excelPernm}
              </FlexLayout>
            </FlexLayout>

            <FlexLayout
              size={200}
              justify="center"
              align="center"
            >
              <span style={{ width: 50 }}>출력일자</span>
              <FlexLayout size={110} style={{ border: '1px solid lightgray', borderRadius: '4px', backgroundColor: '#F7F7F7' }}>{Date8.withDash(modalStore.excelDate)}</FlexLayout>
            </FlexLayout>
          </FlexLayout>

          <SubHeader>
            <FlexLayout>
              <Button onClick={() => toolStore.onExcelHistory()}>확인</Button>
              <Button onClick={() => modalStore.closeExcel()}>닫기</Button>
            </FlexLayout>
          </SubHeader>

        </FlexLayout>
      </ModalView>
    );
  }
}
